import { useState } from 'react';
import './SettingsSection.scss';

interface SettingsSectionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export function SettingsSection({ title, children, defaultOpen = false }: SettingsSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className="settings-section">
      <button
        type="button"
        className="settings-section__header"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className={`settings-section__chevron ${open ? 'settings-section__chevron--open' : ''}`}>
          &#9654;
        </span>
        <span className="settings-section__title">{title}</span>
      </button>
      {open && (
        <div className="settings-section__content">
          {children}
        </div>
      )}
    </section>
  );
}
